var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9504 12L16.8254 6.575C17.0587 6.24167 17.0879 5.89583 16.9129 5.5375C16.7379 5.17917 16.4421 5 16.0254 5C15.8587 5 15.7004 5.0375 15.5504 5.1125C15.4004 5.1875 15.2837 5.29167 15.2004 5.425L10.5004 12L15.2004 18.575C15.2837 18.7083 15.4004 18.8125 15.5504 18.8875C15.7004 18.9625 15.8587 19 16.0254 19C16.4254 19 16.7171 18.8208 16.9004 18.4625C17.0837 18.1042 17.0587 17.7583 16.8254 17.425L12.9504 12ZM7.00039 12L10.8754 6.575C11.1087 6.24167 11.1379 5.89583 10.9629 5.5375C10.7879 5.17917 10.4921 5 10.0754 5C9.90872 5 9.75039 5.0375 9.60039 5.1125C9.45039 5.1875 9.33372 5.29167 9.25039 5.425L4.55039 12L9.25039 18.575C9.33372 18.7083 9.45039 18.8125 9.60039 18.8875C9.75039 18.9625 9.90872 19 10.0754 19C10.4754 19 10.7671 18.8208 10.9504 18.4625C11.1337 18.1042 11.1087 17.7583 10.8754 17.425L7.00039 12Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/Collapse.19eb4e6422bf25e87c16856e400d57de.svg";
export { ForwardRef as ReactComponent };